import { 
  GET_CHEMICAL_ANALYSIS_FAILURE, 
  GET_CHEMICAL_ANALYSIS_REQUEST, 
  GET_CHEMICAL_ANALYSIS_SUCCESS 
} from "./chemicalAnalysisTypes";

const initialState = {
  loading: false,
  chemicalAnalysis: [],
  error: "",
};

const getChemicalAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHEMICAL_ANALYSIS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CHEMICAL_ANALYSIS_SUCCESS:
      return {
        loading: false,
        chemicalAnalysis: action.payload,
        error: "",
      };
    case GET_CHEMICAL_ANALYSIS_FAILURE:
      return {
        loading: false,
        chemicalAnalysis: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

export { getChemicalAnalysisReducer };